import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, Output } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { EdCheckboxModule } from "@edenred/components/checkbox";
import { EdInputFieldModule } from "@edenred/components/input";
import { EdInputWrapperModule } from "@edenred/components/input-wrapper";
import { EdSelectModule } from "@edenred/components/select";
import { TranslocoPipe } from "@jsverse/transloco";
import { MultiSelectComponent } from "@merchant-webapp/components";
import { NgSelectModule } from "@ng-select/ng-select";
import { debounceTime, distinctUntilChanged } from "rxjs";

@Component({
  selector: "er-dashboard-filters",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    EdInputWrapperModule,
    NgSelectModule,
    FormsModule,
    EdSelectModule,
    EdInputFieldModule,
    EdCheckboxModule,
    MultiSelectComponent,
    MatIconModule,
    TranslocoPipe,
  ],
  templateUrl: "./dashboard-filters.component.html",
  styleUrls: ["./dashboard-filters.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardFiltersComponent implements OnInit {
  @Output() toggleColumnVisibility: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() filterData: EventEmitter<string> = new EventEmitter<string>();

  public items = [
    {
      label: "dashboard.location_performance.product_items.diesel",
      value: "dieselVolume",
      disabled: false,
    },
    {
      label: "dashboard.location_performance.product_items.petrol",
      value: "petrolVolume",
      disabled: false,
    },
    {
      label: "dashboard.location_performance.product_items.adblue",
      value: "adblueVolume",
      disabled: false,
    },
  ];

  selectedColumns: string[] = [];
  private readonly fb = inject(FormBuilder);

  public filtersForm = this.fb.group({
    textFilter: [""],
  });

  ngOnInit(): void {
    this.selectedColumns = this.items.map((col) => col.value);

    this.filtersForm.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((formValue) => {
      this.filterData.emit(formValue.textFilter as string);
    });
  }

  public changeColumnVisibility(e: string[]) {
    this.selectedColumns = e;
    this.toggleColumnVisibility.emit(e);
  }
}
